import { render, staticRenderFns } from "./VideoJS.vue?vue&type=template&id=3b3fdfac&"
import script from "./VideoJS.vue?vue&type=script&lang=js&"
export * from "./VideoJS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports